export const scrollToBottom = () => {
    let scrollContainer = document.getElementById("chatbox-scroll-div");
    if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
    }
};
